import { render } from "./ModalNotifier.vue?vue&type=template&id=3232309a&scoped=true"
import script from "./ModalNotifier.vue?vue&type=script&lang=js"
export * from "./ModalNotifier.vue?vue&type=script&lang=js"

import "./ModalNotifier.vue?vue&type=style&index=0&id=3232309a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3232309a"

export default script